import { getMethodWithToken } from 'utils/services/apiService';
import url from 'utils/services/urls.json';

// Action Types
export const GET_SKIN_CONCERNS = 'GET_SKIN_CONCERNS';
export const GET_SKIN_CONCERNS_SUCCESS = 'GET_SKIN_CONCERNS_SUCCESS';
export const GET_SKIN_CONCERNS_FAILURE = 'GET_SKIN_CONCERNS_FAILURE';

// Action Creators
export const getSkinConcerns = () => ({
  type: GET_SKIN_CONCERNS,
});

export const getSkinConcernsSuccess = (data) => ({
  type: GET_SKIN_CONCERNS_SUCCESS,
  payload: data,
});

export const getSkinConcernsFailure = (error) => ({
  type: GET_SKIN_CONCERNS_FAILURE,
  payload: error,
});

// Thunk Function
export const getSkinConcernsCallAPI = (external) => {
  return async (dispatch) => {
    dispatch(getSkinConcerns());
    try {
      const response = await getMethodWithToken(url.skinConcerns);
      if (response?.status === 200 || response?.status === 201) {
        dispatch(getSkinConcernsSuccess(response?.data));
        if (external?.run === true) {
          external?.handleFunction(response?.data);
        }
      } else if (response?.status === 401 || response?.status === 403) {
        if (external?.authorize === true) {
          external?.handleAuthorizeFunction(response?.data);
        }
      } else {
        external?.handleErrorFunction(response?.data);
        dispatch(getSkinConcernsFailure(response?.data));
      }
    } catch (error) {
      dispatch(getSkinConcernsFailure(error?.message));
    }
  };
};
